// extracted by mini-css-extract-plugin
module.exports = {"container":"e_1xb","default":"e_2xb","featured":"e_3xb"};